import { NAV_ICONS } from "./constants";
import { createNavLink } from "./linkBuilder";

const logoutLink = createNavLink({
  title: "Logout",
  path: "/logout",
  icon: NAV_ICONS.LogOut,
});

export const bottomNavLinks = [
  logoutLink,
];
export { logoutLink };

